import MenuTertiaryItem from "./MenuTertiaryItem";
import "./css/menu-secondary-item.css";

export default function menuSecondaryItem(props) {
  const hasTitle = props.type === "title";
  const label = props?.label;
  const children = props?.menuItems ?? [];
  const hasChildren = children?.length > 0;
  const hasChildrenClass = hasChildren
    ? "menu-secondary-item--has-children"
    : "";
  const url = hasTitle || hasChildren ? false : props?.url;
  const isExternalClass = props?.isExternal
    ? "menu-secondary-item--external"
    : "";
  const isActiveClass = props?.isActive ? "menu-secondary-item--active" : "";
  const classList = [
    "menu-secondary-item",
    `menu-secondary-item--${props.type}`,
    hasChildrenClass,
    isActiveClass,
    isExternalClass,
  ]
    .filter((item) => !!item)
    .join(" ");

  return (
    <li className={classList} aria-expanded={"true"}>
      <a href={url} className="menu-secondary-item__link">
        <span className="menu-secondary-item__label">{label}</span>
        {hasChildren && <span className="menu-secondary-item__chevron"></span>}
      </a>
      {hasChildren && (
        <ul class="menu-secondary-item__children">
          {children.map((item, index) => {
            return <MenuTertiaryItem key={index} {...item} />;
          })}
        </ul>
      )}
    </li>
  );
}
